import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import IconArrow from '@assets/images/icons/arr_down.svg'
import FolderSelectTree from '@/modules/file/components/folder-select-tree'

import lang from '@/lang'
import { useSelector } from 'react-redux'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { CssHelper } from '@/modules/base/view/mixin/helpers_mixin'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
  uploadPath: {
    display: 'flex',
    flexDirection: 'column',
    border: theme.border,
    borderRadius: 5,
    overflow: 'hidden',
    maxHeight: ({ maxHeight }) => maxHeight,
  },
  uploadPathEdit: {
    borderColor: theme.primary,
  },
  uploadPathIcon: {
    marginLeft: 5,
    pointerEvents: 'none',
  },
  trigger: {
    '& svg': {
      fill: theme.lightGrey,
    },
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: CssHelper.px(0, 10),
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.backgroundColor,
    minHeight: 45,
  },
  readOnly: {
    pointerEvents: 'none',
    opacity: 0.75,
  },
  tree: {
    width: '100%',
    flexGrow: 1,
    padding: CssHelper.px(5, 10, 10, 0),
  },
  pathLabel: {
    flexGrow: 1,
  },
  flip: {
    transform: 'rotateZ(180deg)',
  },
}))

const FolderSelect = (props) => {
  const classes = useStyles(props)

  const {
    folders,
  } = useSelector(state => state.document.list)
  const [editPath, setEditPath] = useState(false)

  const { onChange, path, maxHeight = 220, readOnly = false } = props

  const onClick = (value) => {
    if (readOnly) {
      return
    }
    if (value.isRoot) {
      delete value.name
    }
    setEditPath(false)
    onChange(value)
  }

  const scrollOptions = {
    suppressScrollX: true,
    wheelPropagation: false,
  }

  return (
    <div className={clsx(classes.uploadPath, { [classes.uploadPathEdit]: editPath })}>
      <span className={clsx(classes.trigger, { [classes.readOnly]: readOnly })} onClick={() => { if (!readOnly) setEditPath(!editPath) }}>
        <span className={classes.pathLabel}>{`${path || lang.documents.folder.noPath}`}</span>
        <SVGIcon className={clsx(classes.uploadPathIcon, { [classes.flip]: editPath })} svg={IconArrow} width='16px' />
      </span>
      {editPath
        ? <PerfectScrollbar className={classes.tree} options={scrollOptions}>
          <FolderSelectTree {...props} maxHeight={maxHeight} node={folders} onClick={onClick} />
        </PerfectScrollbar>
        : null}
    </div>
  )
}

FolderSelect.propTypes = {
  onChange: PropTypes.func,
  path: PropTypes.string,
  maxHeight: PropTypes.number,
  currentFolder: PropTypes.object,
  readOnly: PropTypes.bool,
}

export default FolderSelect
